"use client";

import { useAuth } from "@wtc/ui";
import { canUseSequences } from "./sequences-access";

/**
 * Client hook: is the Sales Sequences feature visible to the current user?
 * Gate the Sequences nav link, detail tab, row action, and pages on this.
 * See sequences-access.ts — this is UI-hiding only, not security.
 */
export function useSequencesAccess(): boolean {
  const { user } = useAuth();
  return canUseSequences(user?.email);
}
